import script from "./MermaidRenderer.vue?vue&type=script&setup=true&lang=js"
export * from "./MermaidRenderer.vue?vue&type=script&setup=true&lang=js"

import "./MermaidRenderer.vue?vue&type=style&index=0&id=5eede259&scoped=true&lang=css"

import exportComponent from "../../../../../../labcheckup/labhub_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eede259"]])

export default __exports__